import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f34da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title pt_0" }
const _hoisted_3 = { class: "register-container" }
const _hoisted_4 = {
  key: 0,
  class: "text--center"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ma-0" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_8 = ["onChange"]
const _hoisted_9 = { class: "ma-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_11 = {
  key: 1,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 20,
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("register.registration")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "text--center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("register.eventInfo")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "signUp__container"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_card, { class: "box-card mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          (_ctx.eventData.themeSettings.logoURL)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_el_image, {
                                  class: "img-event",
                                  src: _ctx.eventData.themeSettings.logoURL,
                                  alt: "event photo",
                                  fit: "contain"
                                }, null, 8, ["src"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          (_ctx.eventData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_el_form, {
                                  model: _ctx.customFields,
                                  ref: "registerForm"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (input, key, index) => {
                                      return _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
                                        prop: `${key}.value`,
                                        key: index,
                                        required: input.required ? true : false
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", _hoisted_6, [
                                            (input.required)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(input.type == "file"
                            ? input.fileMessage
                            : input.label[_ctx.$i18n.locale]), 1)
                                          ]),
                                          (input.type == 'select')
                                            ? (_openBlock(), _createBlock(_component_el_select, {
                                                key: 0,
                                                class: "input__form-item__select",
                                                modelValue: input.value,
                                                "onUpdate:modelValue": ($event: any) => ((input.value) = $event)
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.selectFieldOptions, (option, index) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      class: "input__form-item__select__options",
                                                      key: index,
                                                      label: option,
                                                      value: option
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                            : (input.type == 'file')
                                              ? (_openBlock(), _createElementBlock("input", {
                                                  key: 1,
                                                  type: "file",
                                                  onChange: ($event: any) => (_ctx.selectChange($event, index))
                                                }, null, 40, _hoisted_8))
                                              : (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: input.value,
                                                  "onUpdate:modelValue": ($event: any) => ((input.value) = $event),
                                                  type: input.type
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "type"]))
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "required"])), [
                                        [_vShow, _ctx.eventData.registrationFormTemplate]
                                      ])
                                    }), 128)),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_9, [
                                          _hoisted_10,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t("register.ticketType")), 1)
                                        ]),
                                        (
                          _ctx.eventData &&
                          _ctx.eventData.ticketTypes &&
                          (_ctx.isQuotaAvailable > 0 ||
                            _ctx.isQuotaAvailable === 'unlimited')
                        )
                                          ? (_openBlock(), _createBlock(_component_el_row, {
                                              key: 0,
                                              class: "register__form-item__select"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, {
                                                  span: _ctx.eventType === 'corporation' ? 16 : 24,
                                                  class: "register__form-item__select"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_select, {
                                                      modelValue: _ctx.participantEventData.ticketType,
                                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.participantEventData.ticketType) = $event))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.ticketTypes, (ticketType) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: ticketType.id,
                                                            label: _ctx.ticketLabelFilter(ticketType),
                                                            value: ticketType.id,
                                                            disabled: 
                                !_ctx.isValidTicket(ticketType.limitRegistationDate)
                              
                                                          }, null, 8, ["label", "value", "disabled"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["span"]),
                                                (_ctx.eventType === 'corporation')
                                                  ? (_openBlock(), _createBlock(_component_el_col, {
                                                      key: 0,
                                                      span: 8
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.isQuotaAvailable !== 'unlimited')
                                                          ? (_openBlock(), _createBlock(_component_el_input_number, {
                                                              key: 0,
                                                              class: "register__form-item__input-number",
                                                              modelValue: _ctx.ticketsQuantity,
                                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ticketsQuantity) = $event)),
                                                              min: 1,
                                                              max: _ctx.isQuotaAvailable,
                                                              "controls-position": "right"
                                                            }, null, 8, ["modelValue", "max"]))
                                                          : (_openBlock(), _createBlock(_component_el_input_number, {
                                                              key: 1,
                                                              class: "register__form-item__input-number",
                                                              modelValue: _ctx.ticketsQuantity,
                                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticketsQuantity) = $event)),
                                                              min: 1,
                                                              "controls-position": "right"
                                                            }, null, 8, ["modelValue"]))
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                              _hoisted_12,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("register.ticketsNotAvailable")), 1)
                                            ]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { class: "text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            style: {"margin-bottom":"10px"},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.send())),
                            class: "button_pay",
                            disabled: _ctx.isQuotaAvailable === 0
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("register.continuePayment")), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}